import React, { Component } from 'react'
import {
  Route,
  Switch
} from 'react-router-dom'
import SwipeableViews from 'react-swipeable-views';
import Tabs, { Tab } from 'material-ui/Tabs';
import Checkbox from 'material-ui/Checkbox';
import Header from '../../template/Header'
import styles from './styles.css'


// session header
import FilterBox from './common/FilterBox'

// session content
import Popular from './Popular/Popular'
import PlaceContainer from '../Place/PlaceContainer'
import FoodContainer from '../Food/FoodContainer'
import OtopContainer from '../Otop/OtopContainer'
import NewsContainer from '../News/NewsContainer'
import HotelsContainer from '../Hotels/HotelsContainer'
import ShoppingContainer from '../Shopping/ShoppingContainer'
import AppShell from '../../template/AppShell'

const Topic = ({ match }) => (
  <div>
    <h3>Content Hone</h3>
  </div>
)

const Home = ({ match }) => (
  <div>
    {/* <FilterBox /> */}
    
    <AppShell>
    <Switch>
      <Route exact path={match.url+"/"} component={Popular}/>
      <Route path={match.url+"/place"} component={PlaceContainer}/>
      <Route path={match.url+"/food"} component={FoodContainer}/>
      {/* <Route path={match.url+"/otop"} component={OtopContainer}/> */}
      <Route path={match.url+"/news"} component={NewsContainer}/>
      <Route path={match.url+"/hotels"} component={HotelsContainer}/>
      <Route path={match.url+"/shopping"} component={ShoppingContainer}/>
      {/* <Route component={Popular}/> */}
    </Switch>
    
    </AppShell>
  </div>
)
export default Home



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js